import { Component, OnInit, OnChanges, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
  selector: 'navaar-like-icon',
  template: `
  <svg xmlns="http://www.w3.org/2000/svg" width="18.286" height="16" viewBox="0 0 18.286 16">
                <g id="_2087973" data-name="2087973" transform="translate(0 -1)" opacity="0.499">
                  <path id="Path_2954" data-name="Path 2954" d="M0,1V9a1,1,0,0,0,1,1H4V0H1A1,1,0,0,0,0,1Z" transform="translate(0 7)" [attr.fill]="color"/>
                  <path id="Path_2955" data-name="Path 2955" d="M11.055,5.744H7.487a.6.6,0,0,1-.521-.282A.537.537,0,0,1,6.959,4.9L8.217,2.752A1.619,1.619,0,0,0,8.3,1.238,1.774,1.774,0,0,0,7.072.257L6.185.047a.624.624,0,0,0-.6.172L.774,5.281A2.771,2.771,0,0,0,0,7.193v5.98A2.945,2.945,0,0,0,3.019,16.03H9.027a3,3,0,0,0,2.912-2.1l1.289-5.6a2.017,2.017,0,0,0,.057-.475,2.176,2.176,0,0,0-2.23-2.11Z" transform="translate(5 0.97)" [attr.fill]="color"/>
                </g>
              </svg>
              `,
  styles: [`
    :host(){
      vertical-align: 3px;
    }
  `]
})
export class LikeIconComponent implements OnInit, OnChanges {
  ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
    if (changes.isLike && !changes.isLike.firstChange) {
      this.changeColor(changes.isLike.currentValue);
    }
  }
  @HostListener('click')
  public onClickEv() {
    this.clicked.emit();
  }
  @Input('is-like-from-user') public isLike: boolean;
  @Output('onClick') public clicked: EventEmitter<any> = new EventEmitter<any>();
  public color: string;
  constructor() { }

  ngOnInit(): void {
    this.changeColor(this.isLike);
  }
  private changeColor(state: boolean) {
    this.color = state ? '#00AA7D' : '#adadad';
  }
}
